export default "__VITE_ASSET__BPDvRbxP__"